import { render, staticRenderFns } from "./avatar-uploader.vue?vue&type=template&id=8e4ab6dc&scoped=true&"
import script from "./avatar-uploader.vue?vue&type=script&lang=js&"
export * from "./avatar-uploader.vue?vue&type=script&lang=js&"
import style0 from "cropperjs/dist/cropper.css?vue&type=style&index=0&lang=css&"
import style1 from "./avatar-uploader.vue?vue&type=style&index=1&id=8e4ab6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ab6dc",
  null
  
)

export default component.exports